import { gql } from '@apollo/client'

export default gql`
  {
    searchHeroInView @client
  }
`
